// extracted by mini-css-extract-plugin
export default {"form":"form_form__GNhEm","spanner":"form_spanner__6oUes","sectionTitle":"form_sectionTitle__j-mUy"};